import { render, staticRenderFns } from "./AltPeriodSpendingsPopup.vue?vue&type=template&id=827bcb8c&"
import script from "./AltPeriodSpendingsPopup.vue?vue&type=script&lang=js&"
export * from "./AltPeriodSpendingsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports